import { Button } from '@material-ui/core';
import React, { useState } from 'react';

function AdminLogin(props) {
    // state variables
    const [userName , setUserName] = useState('')
    const [password , setPassword] = useState('')
    const [loginStatus , setLoginStatus] = useState(false)


    const submitForm = (e) => {
        e.preventDefault();
        if(userName === "admin" && password === "12345" ){
            setLoginStatus(true)
            sessionStorage.setItem('loggedIn' , true)
            sessionStorage.setItem('loggedInUser','admin')
            sessionStorage.setItem('userName','admin')
            sessionStorage.setItem('emailId','admin@gmail.com')
            window.location.reload()
        }

    }
    const handleChange = (e) =>{
        if (e.target.name === "userName") {
            setUserName(e.target.value)
        } else if (e.target.name === "password") {
            setPassword(e.target.value)
        }

    }
    
    return (
        <div>
            <form className="Input_Field_container" onSubmit={submitForm}>
                <p>
                    <i class="fa fa-user"></i>{" "}
                    <input
                        className="Input_fields"
                        type="text"
                        placeholder="Username"
                        name="userName"
                        title="Password must be 8 Characters"
                        value={userName}
                        onChange={handleChange}
                    />
                </p>
                <p>
                    {" "}
                    <i class="fa fa-lock"></i>{" "}
                    <input
                        className="Input_fields"
                        type="password"
                        placeholder="Password"
                        name="password"
                        value={password}
                        onChange={handleChange}
                    />
                </p>
                <Button type="submit" variant="contained" className="login-btn">Login</Button>
            </form>
        </div>
    );
}

export default AdminLogin;